/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import FundoAmarelo from '../../../assets/fundo_amarelo.png';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { ExcluirRegistro } from './atom/ExcluirRegistro.jsx';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { EditarGruposTvs } from './atom/EditarGruposTvs.jsx';
import { VincularLinks } from './atom/VincularLinks.jsx';
import { VincularTVs } from './atom/VincularTVs.jsx';

import DialogCrud from '../shared/DialogCrud.jsx';
import { FormCadastrarGrupo } from './atom/FormCadastrarGrupo.jsx';

import './style.css';
import grupoTvService from '../../../services/tvs/grupoTvService.js';

export function CadastrarGruposTVs() {
    const [dadosParametros, setDadosParametros] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [modalEdicaoAberto, setModalEdicaoAberto] = useState(false);
    const [modalVincularLinkAberto, setModalVincularLinkAberto] = useState(false);
    const [modalVincularTVAberto, setModalVincularTVAberto] = useState(false);
    const [recarregarDataTable, setRecarregarDataTable] = useState(true);
    const [rowSelecionada, setRowSelecionada] = useState([]);

    const [openModalCadastro,setOpenModalCadastro] = useState(false);

    const abrirModal = () => setModalAberto(true);
    const abrirModalEdicao = () => setModalEdicaoAberto(true);
    const abrirModalVincularLink = () => setModalVincularLinkAberto(true);
    const abrirModalVincularTV = () => setModalVincularTVAberto(true);

    const vincularLinkB = rowData => (

        <i className="pi pi-link"
            onClick={() => {
                abrirModalVincularLink();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em',
                color: '#03258C' }}></i>

    );

    const VincularTVsB = rowData => (

        //<MultipleSelect rowData={rowData}/>
        <i className="pi pi-link"
            onClick={() => {
                abrirModalVincularTV();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em',
                color: '#03258C' }}></i>

    );

    // const bodyStatus = rowData => `${tiposDeStatus[rowData.Status]}` || `${tiposDeStatus.default}`;

    const bodyAcoes = rowData => (
        <div className="acoes" style={{ display: 'flex',
            gap: '8px',
            justifyItems: 'center',
            justifyContent: 'space-evenly',
            color: '#03258C'  }}>

            <i className="pi pi-trash"  onClick={() => {
                abrirModal();
                setRowSelecionada(rowData.id);
            }} style={{ 'fontSize': '2em' }}></i>
            <i className="pi pi-pencil"
                onClick={() => {
                    abrirModalEdicao();
                    setRowSelecionada(rowData);
                }} style={{ 'fontSize': '2em' }}></i>
        </div>
    ); //

    const header = <img src={FundoAmarelo} />;

    useEffect(() => {
        (async () => {
            try {
                const { data } = await grupoTvService.getGrupo();

                setDadosParametros(data);
                setRecarregarDataTable(false);
            } catch {
                setRecarregarDataTable(false);
                throw new Error();
            }
        })();
    }, [recarregarDataTable]);

    const zero = 0;

    return (
        <Card className='tratar-scroll-card' header={header} title="Grupos(Grade de programação)">
            <div className="p-col">
                <div className="p-grid p-fluid">
                    <div className="p-col size-spinner">

                        <Card >
                            <Button style={{ width: '95px' }} label={'Cadastrar'} onClick={setOpenModalCadastro.bind(this,true)}/>
                            <DialogCrud title={'Cadastrar grupo'} openModal={openModalCadastro} setOpenModal={setOpenModalCadastro}>
                                <FormCadastrarGrupo setOpenModalCadastro={setOpenModalCadastro} setRecarregarDataTable={setRecarregarDataTable} />
                            </DialogCrud>
                        </Card>
                        <DataTable
                            paginator
                            responsive
                            rows={5}
                            style={{ textAlign: 'center',
                                overflow: 'hidden' }}
                            value={dadosParametros.filter(s => s.status != zero)}
                            scrollable={false}
                            sortField="dataUpdated"
                            sortOrder={-1}
                            loading={recarregarDataTable}
                            loadingIcon="pi pi-spin pi-spinner"
                            emptyMessage="Sem Grupos cadastrados"
                        >
                            <Column
                                field="nome"
                                header="Nome do link"
                                style={{ width: '14rem',
                                    height: '4rem' }}
                                filter
                                filterPlaceholder="Filtrar por nome"
                            />
                            <Column
                                header="Vincular links"
                                body={(e , v) => vincularLinkB(v)}
                                style={{
                                    overflow: 'hidden',
                                    width: '14rem',
                                    height: '4rem'
                                }}
                            />
                            <Column
                                header="Vincular aparelhos televisores"
                                body={VincularTVsB}
                                style={{ width: '14rem',
                                    height: '4rem' }}
                            />

                            <Column
                                header="Ações"
                                body={bodyAcoes}
                                style={{ width: '14rem',
                                    height: '4rem' }}
                            />
                        </DataTable>
                    </div>

                    <ExcluirRegistro
                        rowSelecionada={rowSelecionada}
                        modalAberto={modalAberto}
                        setModalAberto={setModalAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />

                    <EditarGruposTvs
                        rowSelecionada={rowSelecionada}
                        modalEdicaoAberto={modalEdicaoAberto}
                        setModalEdicaoAberto={setModalEdicaoAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                    <VincularLinks
                        rowSelecionada={rowSelecionada}
                        modalVincularLinkAberto={modalVincularLinkAberto}
                        setModalVincularLinkAberto={setModalVincularLinkAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                    <VincularTVs
                        rowSelecionada={rowSelecionada}
                        modalVincularTVAberto={modalVincularTVAberto}
                        setModalVincularTVAberto={setModalVincularTVAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                </div>
            </div>
        </Card>
    );
}
